<template>
  <v-card :elevation="1"
          rounded="lg"
          class="pa-4"
          style="height:100%; width:100%; overflow: scroll">
    <div class="font-weight-bold text-lg">
      {{ conf.title }}
      <span
          class="font-weight-medium grey--text text--lighten-1">périodes n-1 {{
          conf.data.fullperiod ? "complète" : "à dates"
        }}</span>
    </div>
    <v-data-table class="mt-3"
                  :loading="items.length < 1 && loading"
                  :headers="headers"
                  :items="items"
                  search-field="name"
                  item-key="name"
                  hide-default-footer
                  v-if="items.length > 0"
    >
      <template v-slot:header.day="{header}" v-if="!conf.data.fullperiod">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div class="d-flex flex-column justify-space-around">
              <p v-bind="attrs" class="mb-0"
                 v-on="on">{{ header.text }}
              </p>
<!--              <span class="caption grey&#45;&#45;text lighten-1">{{ getDescSubHeader(header.value) }}</span>-->
            </div>

          </template>
          <div class="d-flex flex-column caption" v-html="getTooltipPeriod(header.value)"/>
        </v-tooltip>

      </template>
      <template v-slot:header.ten="{header}" v-if="!conf.data.fullperiod">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div class="d-flex flex-column justify-space-around">
              <p v-bind="attrs" class="mb-0"
                 v-on="on">{{ header.text }}
              </p>
<!--              <span class="caption grey&#45;&#45;text lighten-1">{{ getDescSubHeader(header.value) }}</span>-->
            </div>

          </template>
          <div class="d-flex flex-column caption" v-html="getTooltipPeriod(header.value)"/>
        </v-tooltip>

      </template>
      <template v-slot:header.thirty="{header}" v-if="!conf.data.fullperiod">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div class="d-flex flex-column justify-space-around">
              <p v-bind="attrs" class="mb-0"
                 v-on="on">{{ header.text }}
              </p>
<!--              <span class="caption grey&#45;&#45;text lighten-1">{{ getDescSubHeader(header.value) }}</span>-->
            </div>

          </template>
          <div class="d-flex flex-column caption" v-html="getTooltipPeriod(header.value)"/>
        </v-tooltip>

      </template>
      <template v-slot:header.ninety="{header}" v-if="!conf.data.fullperiod">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div class="d-flex flex-column justify-space-around">
              <p v-bind="attrs" class="mb-0"
                 v-on="on">{{ header.text }}
              </p>
<!--              <span class="caption grey&#45;&#45;text lighten-1">{{ getDescSubHeader(header.value) }}</span>-->
            </div>

          </template>
          <div class="d-flex flex-column caption" v-html="getTooltipPeriod(header.value)"/>
        </v-tooltip>

      </template>
      <template v-slot:header.year="{header}" v-if="!conf.data.fullperiod">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <div class="d-flex flex-column justify-space-around">
              <p v-bind="attrs" class="mb-0"
                 v-on="on">{{ header.text }}
              </p>

<!--              <div>
                <span class="caption grey&#45;&#45;text lighten-1">{{ getDescSubHeader(header.value).old }}</span>
                <span>{{ getDescSubHeader(header.value).act }}</span></div>-->
            </div>

          </template>
          <div class="d-flex flex-column caption" v-html="getTooltipPeriod(header.value)"/>
        </v-tooltip>

      </template>
      <template v-slot:body="{ items }">
        <tbody>
        <tr
            v-for="item in items"
            :key="item.name"
        >
          <td class="">{{ item.name }}</td>
          <td class="text-right">
            <div class="d-flex flex-column">
              <span class=""> {{ _formatCurrency(item.day.value, "EUR") }}</span>
              <span class="caption grey--text lighten-1">{{
                  _formatCurrency(item.day.oldValue, "EUR")
                }}
                <span :class="['ml-2',item.day.evo[0] === '-' ? 'red--text' : 'green--text']">{{ item.day.evo }}</span></span>
            </div>
          </td>
          <td class="text-right">
            <div class="d-flex flex-column">
              <span class=""> {{ _formatCurrency(item.ten.value, "EUR") }}</span>
              <span class="caption grey--text lighten-1">{{
                  _formatCurrency(item.ten.oldValue, "EUR")
                }}
                <span :class="['ml-2',item.ten.evo[0] === '-' ? 'red--text' : 'green--text']">{{
                    item.ten.evo
                  }}</span>
              </span>
            </div>
          </td>
          <td class="text-right">
            <div class="d-flex flex-column">
              <span class=""> {{ _formatCurrency(item.thirty.value, "EUR") }}</span>
              <span class="caption grey--text lighten-1">{{
                  _formatCurrency(item.thirty.oldValue, "EUR")
                }}
                <span :class="['ml-2',item.thirty.evo[0] === '-' ? 'red--text' : 'green--text']">{{
                    item.thirty.evo
                  }}</span>
              </span>
            </div>
          </td>
           <td class="text-right">
            <div class="d-flex flex-column">
              <span class=""> {{ _formatCurrency(item.ninety.value, "EUR") }}</span>
              <span class="caption grey--text lighten-1">{{
                  _formatCurrency(item.ninety.oldValue, "EUR")
                }}
                <span :class="['ml-2',item.ninety.evo[0] === '-' ? 'red--text' : 'green--text']">{{
                    item.ninety.evo
                  }}</span>
              </span>
            </div>
          </td>
          <td class="text-right">
            <div class="d-flex flex-column">
              <span class=""> {{ _formatCurrency(item.year.value, "EUR") }}</span>
              <span class="caption grey--text lighten-1">{{
                  _formatCurrency(item.year.oldValue, "EUR")
                }}
                <span :class="['ml-2',item.year.evo[0] === '-' ? 'red--text' : 'green--text']">{{
                    item.year.evo
                  }}</span>
              </span>
            </div>
          </td>
        </tr>
        </tbody>

      </template>


    </v-data-table>
  </v-card>
</template>
<script>
import {EventBus} from "@/components/commons/event-bus";
import {get, post} from "@/utils/api";
// Chiffres d'affaires par site par jour(données année n-1)
export default {
  name: "WidgetDaysCA",

  data() {
    return {
      loading: false,
      items: [],
      headers: [
        {
          text: "Site",
          value: "name",
          align: "left",
          sortable: false,
        },
          {
          text: "Hier (€)",
          value: "day",
          align: "right",
          sortable: false,
        },
        {
          text: "10 derniers Jours (€)",
          value: "ten",
          align: "right",
          sortable: false,
        },
        {
          text: "30 derniers Jours (€)",
          value: "thirty",
          align: "right",
          sortable: false,
        },
        {
          text: "90 derniers Jours (€)",
          value: "ninety",
          align: "right",
          sortable: false,
        },
        {
          text: "365 derniers jours",
          value: "year",
          align: "right",
          sortable: false,
        }],
      url: `/api/widget/dashboard/ca/site/days`,
      totaux: {},
      totauxPast: {}
    }
  },
  props: {
    form: {type: Object, required: true},
    conf: {type: Object, required: false, default: null}
  },
  created() {
    this.init()
    EventBus.$on('searchDashboard', () => this.init());
  },
  computed: {},
  methods: {
    init() {

      this.items = []
      post(this.url, this.conf.data.sites, {"Content-Type": "application/json"})
          .json(r => {
            let dataList = []
            r.one_day.forEach(site => {
              dataList.push({
                name: site.name,
                day: {
                  startPeriod: site.startPeriod,
                  endPeriod: site.endPeriod,
                  oldStartPeriod: site.oldStartPeriod,
                  oldEndPeriod: site.oldEndPeriod,
                  value: this._formatCurrency(site.value, "EUR"),
                  oldValue: this._formatCurrency(site.oldValue, "EUR"),
                  evo: this.evolution(site.value, site.oldValue)
                },
              })
            })
            dataList.map(data => {

              const byTen = r.by_ten.find(site => site.name == data.name)
              const bythirty = r.by_thirty.find(site => site.name == data.name)
              const byNinety = r.by_ninety.find(site => site.name == data.name)
              const byYear = r.by_year.find(site => site.name == data.name)

              data.ten = {
                startPeriod: byTen.startPeriod,
                endPeriod: byTen.endPeriod,
                oldStartPeriod: byTen.oldStartPeriod,
                oldEndPeriod: byTen.oldEndPeriod,
                value: this._formatCurrency(byTen.value, "EUR"),
                oldValue: this._formatCurrency(byTen.oldValue, "EUR"),
                evo: this.evolution(byTen.value, byTen.oldValue)
              }

              data.thirty = {
                startPeriod: bythirty.startPeriod,
                endPeriod: bythirty.endPeriod,
                oldStartPeriod: bythirty.oldStartPeriod,
                oldEndPeriod: bythirty.oldEndPeriod,
                value: this._formatCurrency(bythirty.value, "EUR"),
                oldValue: this._formatCurrency(bythirty.oldValue, "EUR"),
                evo: this.evolution(bythirty.value, bythirty.oldValue)
              }

              data.ninety = {
                startPeriod: byNinety.startPeriod,
                endPeriod: byNinety.endPeriod,
                oldStartPeriod: byNinety.oldStartPeriod,
                oldEndPeriod: byNinety.oldEndPeriod,
                value: this._formatCurrency(byNinety.value, "EUR"),
                oldValue: this._formatCurrency(byNinety.oldValue, "EUR"),
                evo: this.evolution(byNinety.value, byNinety.oldValue)
              }
              data.year = {
                startPeriod: byYear.startPeriod,
                endPeriod: byYear.endPeriod,
                oldStartPeriod: byYear.oldStartPeriod,
                oldEndPeriod: byYear.oldEndPeriod,
                value: this._formatCurrency(byYear.value, "EUR"),
                oldValue: this._formatCurrency(byYear.oldValue, "EUR"),
                evo: this.evolution(byYear.value, byYear.oldValue)
              }
            })
            this.items.push(...dataList, this.getTotal(r))
          })
    },
    getTotal(list) {
      let dayTotal = 0
      let dayOld = 0
      let tenTotal = 0
      let tenOld = 0
      let thirtyTotal = 0
      let thirtyOld = 0
      let ninetyTotal = 0
      let ninetyOld = 0
      let yearTotal = 0
      let yearOld = 0
      list.one_day.forEach(day => {
        dayTotal += day.value
        dayOld += day.oldValue
      })
      list.by_ten.forEach(ten => {
        tenTotal += ten.value
        tenOld += ten.oldValue
      })
      list.by_thirty.forEach(thirty => {
        thirtyTotal += thirty.value
        thirtyOld += thirty.oldValue
      })
      list.by_ninety.forEach(ninety => {
        ninetyTotal += ninety.value
        ninetyOld += ninety.oldValue
      })
      list.by_year.forEach(y => {
        yearTotal += y.value
        yearOld += y.oldValue
      })

      return {
        name: "Totaux",
        day:
            {
              value: dayTotal,
              oldValue: dayOld,
              evo: this.evolution(dayTotal, dayOld)
            },
        ten: {
          value: tenTotal,
          oldValue: tenOld,
          evo: this.evolution(tenTotal, tenOld)
        },
        thirty: {value: thirtyTotal, oldValue: thirtyOld, evo: this.evolution(thirtyTotal, thirtyOld)},
        ninety: {value: ninetyTotal, oldValue: ninetyOld, evo: this.evolution(ninetyTotal, ninetyOld)},
        year: {value: yearTotal, oldValue: yearOld, evo: this.evolution(yearTotal, yearOld)},
      }
    },
    evolution(act, old) {
      const result = this._formatEvolutionPercent(old, act)
      return result[0] == "-" ? result : "+" + result;
    },
    getDescSubHeader(duration) {
      if (duration == 'year') {
        return {
          old: this._formatDate(new Date(this.items[0][duration].oldStartPeriod), 'dd-MM-yyyy'),
          act: this._formatDate(new Date(this.items[0][duration].startPeriod), 'dd-MM-yyyy')
        }
      } else {
        return this._formatDate(new Date(this.items[0][duration].startPeriod), 'dd MMM')
      }
    },
    getTooltipPeriod(duration) {
      if (this.items.length > 0) {
        if (duration == 'day') {

          return `Le ${this._formatDate(new Date(this.items[0][duration].startPeriod), 'dd MMM yyyy')}
           comparé au ${this._formatDate(new Date(this.items[0][duration].oldStartPeriod), 'dd MMM yyyy')}`


        } else {
          return `
                Période du ${this._formatDate(new Date(this.items[0][duration].startPeriod), ' EEE dd MMM')}
                au ${this._formatDate(new Date(this.items[0][duration].endPeriod), 'EEE dd MMM yyyy')}, <br/>
                par rapport au ${this._formatDate(new Date(this.items[0][duration].oldStartPeriod), 'EEE dd MMM')}
                jusqu'au ${this._formatDate(new Date(this.items[0][duration].oldEndPeriod), 'EEE dd MMM yyyy')}`

        }
      } else {
        return 'pas de données'
      }
    },

  },

}
</script>